import React from 'react'
import TopBar from '../components/TopBar';
import Scanner3 from '../components/queue/Scanner3';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { createUserAction, getOTp } from '../redux/actions/userActions';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import { baseUrl } from '../redux/actions/baseUrl';
import { toast } from '../utils/toast';
import Loading from '../components/Loading';
import { getHospitalId } from '../utils';
import axiosInstance from '../axiosInstance';

export default function QrRegister() {
    const [start, setStart] = React.useState(false)
    const [scanResult, setScanResult] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    const store = useSelector((state) => state);
    const {success, error, data } = store.createUser;
    const navigate = useNavigate();
    const dispatch = useDispatch();

    console.log('data', data)

    const verify_qr = async (dataQr, type) => {
        try {
            let hospital = await getHospitalId(dataQr);
            if (!hospital) {
                localStorage.removeItem('hospital');
                return;
            }
            const res = await axiosInstance.get(`/auth/check-barcode?qr_code=${encodeURIComponent(dataQr)}&type=${encodeURIComponent(type)}`);

            if (res.data?.success) {
                dispatch(createUserAction(res.data.data?.patient?.system_id));
            }
        } catch (err) {
            setLoading(false);
            toast.error('Please scan your QR Code again')
            localStorage.removeItem('hospital');
            console.log('err', err)
            return false;
        }
    }

    const startStop = () => {
        setStart(!start)
    }
    const handleScanResult = async (data) => {
        let trimmed_data = data.replace(/^(https?:\/\/)/i, '');
        setScanResult(trimmed_data);
        try {
            setLoading(true);
            toast.warning('Please wait while we verify your QR Code...', {
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            await verify_qr(trimmed_data, 'register');

        } catch (err) {
            setLoading(false);
            toast.error('Invalid QR Code');
            console.log('err', err);
        }
    };
    useEffect(() => {
        if (success) {
            toast.success('QR Code verified successfully');
            dispatch(getOTp(data.data?.patient.system_id, data.data?.patient.mobile));
            navigate("/success", { state: data.data?.patient });
        }
        if (error) {
            setLoading(false);
            toast.error('Something went wrong, please try again or you already have an account, you can login with QR', {
                autoClose: 12000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            navigate('/login');
        }
        return () => {
            dispatch({ type: 'CREATE_USER_RESET' })
        };
    }, [success, error]);
    
    return (
        <div className='min-h-screen bg-gradient-to-br from-gray-50 to-gray-100'>
            <TopBar title={'QR Code Scanner'} url={-1} />

            <div className='flex justify-center items-start px-4 py-6 sm:py-8'>
                <div className='w-full max-w-md'>
                    {loading ? (
                        <div className='bg-white rounded-2xl shadow-xl p-8 text-center'>
                            <Loading />
                            <p className='text-gray-600 mt-4'>Verifying your QR code...</p>
                        </div>
                    ) : (
                        <>
                            <div className='bg-white rounded-2xl shadow-xl p-6 sm:p-8 mb-6'>
                                <div className='text-center mb-6'>
                                    <div className='w-16 h-16 bg-primary100 rounded-full flex items-center justify-center mx-auto mb-4'>
                                        <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
                                        </svg>
                                    </div>
                                    <h1 className='text-2xl sm:text-3xl font-bold text-gray-800 mb-2'>
                                        QR Registration
                                    </h1>
                                    <p className='text-gray-600 text-sm sm:text-base leading-relaxed'>
                                        Scan your patient QR code to create your healthcare portal account
                                    </p>
                                </div>

                                <div className='bg-blue-50 border border-blue-200 rounded-xl p-4 mb-6'>
                                    <div className='flex items-start space-x-3'>
                                        <div className='flex-shrink-0'>
                                            <svg className="w-5 h-5 text-blue-600 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                                                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                                            </svg>
                                        </div>
                                        <div>
                                            <p className='text-blue-800 text-sm font-medium'>How to Register</p>
                                            <p className='text-blue-700 text-xs mt-1'>Use the QR code provided by your healthcare provider</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="flex flex-col items-center space-y-6">
                                    <button 
                                        onClick={startStop} 
                                        className={`w-full sm:w-4/5 py-4 px-6 rounded-xl font-semibold text-white transition-all duration-300 transform hover:scale-105 active:scale-95 shadow-lg ${
                                            start 
                                                ? 'bg-red-500 hover:bg-red-600 shadow-red-200' 
                                                : 'bg-primary100 hover:bg-primary100/90 shadow-primary100/20'
                                        }`}
                                    >
                                        <div className='flex items-center justify-center space-x-3'>
                                            <span className='text-lg'>
                                                {start ? "Stop Scanner" : "Start Registration"}
                                            </span>
                                            {start ? (
                                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8 7a1 1 0 00-1 1v4a1 1 0 001 1h4a1 1 0 001-1V8a1 1 0 00-1-1H8z" clipRule="evenodd" />
                                                </svg>
                                            ) : (
                                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clipRule="evenodd" />
                                                </svg>
                                            )}
                                        </div>
                                    </button>

                                    <div className='w-full flex justify-center'>
                                        {start ? (
                                            <div className='w-full max-w-sm'>
                                                <Scanner3
                                                    setStart={setStart}
                                                    start={start}
                                                    type={'register'}
                                                    onScanResult={handleScanResult}
                                                />
                                            </div>
                                        ) : (
                                            <div className='bg-gray-50 rounded-xl p-8 border-2 border-dashed border-gray-300 text-center'>
                                                <img 
                                                    className="w-32 h-32 mx-auto opacity-60" 
                                                    src="./barcode.png" 
                                                    alt="QR Code Placeholder" 
                                                />
                                                <p className='text-gray-500 text-sm mt-4'>
                                                    Tap "Start Registration" to begin
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className='bg-white rounded-xl shadow-lg p-4 mb-4'>
                                <h3 className='text-sm font-semibold text-gray-800 mb-3 text-center'>Registration Steps</h3>
                                <div className='space-y-3'>
                                    <div className='flex items-center space-x-3'>
                                        <div className='w-6 h-6 bg-primary100 text-white rounded-full flex items-center justify-center text-xs font-bold'>1</div>
                                        <span className='text-xs text-gray-600'>Scan your patient QR code</span>
                                    </div>
                                    <div className='flex items-center space-x-3'>
                                        <div className='w-6 h-6 bg-gray-300 text-white rounded-full flex items-center justify-center text-xs font-bold'>2</div>
                                        <span className='text-xs text-gray-600'>Verify your phone number</span>
                                    </div>
                                    <div className='flex items-center space-x-3'>
                                        <div className='w-6 h-6 bg-gray-300 text-white rounded-full flex items-center justify-center text-xs font-bold'>3</div>
                                        <span className='text-xs text-gray-600'>Create your account password</span>
                                    </div>
                                </div>
                            </div>

                            <div className='bg-white rounded-xl shadow-lg p-4'>
                                <div className='flex items-center justify-center space-x-6 text-xs text-gray-600'>
                                    <div className='flex items-center space-x-2'>
                                        <svg className="w-4 h-4 text-primary100" fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
                                        </svg>
                                        <span>Secure</span>
                                    </div>
                                    <div className='flex items-center space-x-2'>
                                        <svg className="w-4 h-4 text-primary100" fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                        </svg>
                                        <span>Fast Setup</span>
                                    </div>
                                    <div className='flex items-center space-x-2'>
                                        <svg className="w-4 h-4 text-primary100" fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                        </svg>
                                            <span>NDPR Compliant</span>
                                    </div>
                                </div>
                            </div>

                            <div className='text-center mt-6'>
                                <p className='text-gray-500 text-sm mb-4'>
                                    Already have an account?{' '}
                                    <button 
                                        onClick={() => navigate('/login')}
                                        className='text-primary100 hover:text-primary100/80 font-medium underline'
                                    >
                                        Sign In
                                    </button>
                                </p> 
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    )
}
